/**
 * Created by rathompson on 1/28/22
 * File: CloudManagedToggle
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import DividerLine from '../../../../../common/components/dividerLine/DividerLine'
import { Toggle } from '@panwds/react-form-legacy'
import { CLOUD_MGMT_DESC, CLOUD_MGMT_LABEL, ERROR_SDWAN_NOT_FOR_ONPREM } from '../../../../constants/LabelConstants'
import { Body } from '@panwds/react-ui'
import Collapse from '../../../../../common/components/collapse/Collapse'
import PanoramaCard from '../../../PanoramaCard/PanoramaCard'
import { useFormContext } from 'react-hook-form'
import { APP_ID_PRISMA_ACCESS_EDITION, APP_ID_PRISMA_ACCESS_PANORAMA, APP_ID_SDWAN } from '../../../../../common/constants/GlobalConstants'

export const ButtonWrapper = styled.div`
  & button {
    height: 20px;
    width: 34px;
    align-items:center;
    & button > span > span > svg {
      height:60px;
      width:60px;
    }
  }
  & span {
    height:15px;
    width:18px;
  }
`

const CloudManagedToggle = (props) => {
  const { loading, cloudEnabled, licenses, setError, isPanoramaLocked, isAmend, selectedTSGInstances, setIsCloudPlatform } = props
  const { setValue, trigger } = useFormContext()
  const [isCloudManaged, setIsCloudManaged] = useState(true)
  const [isPanoramaInstance, setPanoramaInstance] = useState(false)
  useEffect(() => {
    if (isPanoramaLocked) {
      setIsCloudManaged(false)
    }
    else {
      setIsCloudManaged(true)
    }
    const hasPanoramaInst = selectedTSGInstances?.some(each => each.app_id === APP_ID_PRISMA_ACCESS_PANORAMA)
    if (hasPanoramaInst || isPanoramaLocked) {
      setPanoramaInstance(true)
      setIsCloudManaged(false)
    }
    else {
      setPanoramaInstance(false)
      setIsCloudManaged(true)
    }
  }, [isPanoramaLocked, isAmend, selectedTSGInstances])

  useEffect(() => {
    setIsCloudPlatform(isCloudManaged)
  }, [isCloudManaged, setIsCloudPlatform])

  useEffect(() => {
    setValue('platform', isCloudManaged)
    trigger('platform')
  }, [isCloudManaged, setValue, trigger])

  const validateToggle = useCallback((value) => {
    if (!value && licenses.find(each => each.app_id === APP_ID_PRISMA_ACCESS_EDITION)?.entitlements.some(each => each.app_id === APP_ID_SDWAN && each.asset_type === 'addon')) {
      return ERROR_SDWAN_NOT_FOR_ONPREM
    }
    return true
  }, [licenses])


  return (
    <div>
      <DividerLine />
      <div className="tw-flex tw-items-center">
        <div className="tw-flex tw-gap-2 tw-items-center" style={{ flex: 1 }}>
          <ButtonWrapper>
            <Toggle
              disabled={loading || isPanoramaLocked || isAmend || isPanoramaInstance}
              addClassName="tw-m-0"
              defaultValue={cloudEnabled && isCloudManaged}
              name={'platform'}
              label={CLOUD_MGMT_LABEL}
              // style={{width:}}
              showLabel={false}
              register={{
                onChange: (event) => {
                  setIsCloudManaged(event?.target?.value)
                  setIsCloudPlatform(event?.target?.value)
                },
                validate: (value) => validateToggle(value)
              }}
            />
          </ButtonWrapper>
          <Body>{CLOUD_MGMT_LABEL}</Body>
        </div>
        <div className="tw-flex" style={{ flex: 2 }}>
          <Body>{CLOUD_MGMT_DESC}</Body>
        </div>
      </div>
      <DividerLine />
      <Collapse isOpen={!isCloudManaged}>
        <PanoramaCard {...{ loading, isCloudManaged, licenses, setError, selectedTSGInstances }} />
        <DividerLine />
      </Collapse>
    </div>
  )
}

CloudManagedToggle.propTypes = {}
export default CloudManagedToggle
